import { useState } from 'react';
import { MapContainer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import type { TripRoute } from '../../types/trip';
import { MAP_CENTER, MAP_ZOOM } from '../../utils/constants';
import type { InterpolatedPosition, RouteStop } from '../../utils/vehicleHistory';
import { RouteHistoryLayers } from './RouteHistoryLayers';
import { MapTiles, MapStyleSelector, MapResizeHandler, type MapStyleMode } from './mapBase';

interface RouteHistoryMapProps {
  route: TripRoute | null;
  playbackPosition: InterpolatedPosition | null;
  stops: RouteStop[];
  following: boolean;
  onStopFollowing: () => void;
}

/**
 * FE-27 — el mapa de la página propia del histórico (mobile): solo el
 * recorrido. A diferencia de `MapView` no trae vehículos en vivo, cluster ni
 * leyenda — igual que la app de referencia, la pantalla es la reproducción.
 */
export function RouteHistoryMap({ route, playbackPosition, stops, following, onStopFollowing }: RouteHistoryMapProps) {
  const [mapStyle, setMapStyle] = useState<MapStyleMode>('satellite');

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <MapStyleSelector mapStyle={mapStyle} onChange={setMapStyle} />
      <MapContainer
        center={MAP_CENTER}
        zoom={MAP_ZOOM}
        style={{ width: '100%', height: '100%' }}
        zoomControl={false}
      >
        <MapTiles mapStyle={mapStyle} />
        <MapResizeHandler />
        <RouteHistoryLayers
          route={route}
          playbackPosition={playbackPosition}
          stops={stops}
          following={following}
          onStopFollowing={onStopFollowing}
        />
      </MapContainer>
    </div>
  );
}
